import React from "react";
import GameOfLife from "../components/GameOfLife";

const GamePage = () => {
  return (
    <div className="game-page flex justify-center">
      <GameOfLife />
    </div>
  );
};

export default GamePage;
